import styled from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const StyledBubble = styled.div`
  ${tw`tw-bg-white tw-shadow-md tw-border-theme-200 tw-rounded-lg tw-border tw-border-solid tw-text-theme-800 tw-opacity-100 tw-block tw-visible`}
  transition: opacity 0.2s, visibility 0.2s;
  ${FontStyle}
  ${BoxSizingStyle}
  background-color: var(--page-paper-main);
`;

StyledBubble.displayName = "StyledBubble";
